import { CASQuickLinks } from '../../../cimsPage/instances/cas'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: CASQuickLinks,
  create: '00be8fab-0795-44aa-a82b-9fe39e5dc658',
  view: '5c198284-98e8-48d1-a2ce-06557e021c73',
  edit: 'd9066b29-88df-46b6-b2e0-94f94759611c',
  removeRestore: '9c046853-d0f4-4c34-a1f1-8b315165527d',
})

export const CreateCASQuickLink = quickLinks.Create
export const ViewCASQuickLink = quickLinks.View
export const EditCASQuickLink = quickLinks.Edit
export const RemoveRestoreCASQuickLink = quickLinks.RemoveRestore

export type CASQuickLinkPermission =
  | typeof CreateCASQuickLink
  | typeof ViewCASQuickLink
  | typeof EditCASQuickLink
  | typeof RemoveRestoreCASQuickLink
